var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckboxChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    width: 208,
    height: 208,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1C3.253906 1 1 3.253906 1 6L1 20C1 22.746094 3.253906 25 6 25L20 25C22.746094 25 25 22.746094 25 20L25 6C25 3.253906 22.746094 1 20 1 Z M 6 3L20 3C21.65625 3 23 4.34375 23 6L23 20C23 21.65625 21.65625 23 20 23L6 23C4.34375 23 3 21.65625 3 20L3 6C3 4.34375 4.34375 3 6 3 Z M 17.1875 7.0625C17.039063 7.085938 16.914063 7.164063 16.8125 7.3125L11.90625 14.59375L9.59375 12.3125C9.394531 12.011719 9.011719 11.988281 8.8125 12.1875L7.90625 13.09375C7.707031 13.394531 7.707031 13.800781 7.90625 14L11.40625 17.5C11.605469 17.601563 11.886719 17.8125 12.1875 17.8125C12.386719 17.8125 12.707031 17.707031 12.90625 17.40625L18.90625 8.59375C19.105469 8.292969 18.992188 8.011719 18.59375 7.8125L17.59375 7.09375C17.492188 7.042969 17.335938 7.039063 17.1875 7.0625Z",
    fill: "#5683c9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/checkbox-checked.2526e17479e8e04df55f5cde02baa9fd.svg";
export { ForwardRef as ReactComponent };